import * as Tone from "tone";

export default Tone;
